import { html } from 'onefold';
import { CodeBlock } from '../../components/CodeBlock';
import { Callout } from '../../components/Callout';

export function CrossFrameworkPage(): Node {
  return html`
    <div>
      <h1>Cross-Framework Integration</h1>
      <p>Embed React, Vue, or other framework components inside onefold apps — or load legacy apps in isolated iframes.</p>

      <h2>embedForeign (React/Vue)</h2>
      ${CodeBlock(`import { embedForeign } from 'onefold/interop';

// Embed a React component
const ReactWidget = embedForeign({
  mount: (container, props) => {
    import('react-dom/client').then(({ createRoot }) => {
      const root = createRoot(container);
      root.render(React.createElement(MyReactComponent, props));
      return { root };
    });
  },
  unmount: (container, { root }) => {
    root.unmount();
  },
  props: { title: 'Hello from onefold' },
});`)}

      <h2>Embed Vue</h2>
      ${CodeBlock(`const VueWidget = embedForeign({
  mount: (container, props) => {
    import('vue').then(({ createApp }) => {
      const app = createApp(MyVueComponent, props);
      app.mount(container);
      return { app };
    });
  },
  unmount: (container, { app }) => {
    app.unmount();
  },
  props: { message: 'Hello from onefold' },
});`)}

      <h2>loadRemote with iframe (Legacy)</h2>
      <p>For legacy jQuery/Angular.js apps that pollute globals:</p>
      ${CodeBlock(`loadRemote({
  url: 'https://legacy.example.com/widget.js',
  isolation: 'iframe',
  fallback: () => html\`<p>Loading legacy widget...</p>\`,
});`)}

      ${Callout('iframe isolation is the safest option for legacy code that uses document.write, global variables, or older module formats.')}

      <h2>Comparison</h2>
      <table>
        <tr><th>Approach</th><th>Framework</th><th>Isolation</th><th>Performance</th></tr>
        <tr><td><code>embedForeign</code></td><td>React, Vue, Svelte</td><td>None (shared DOM)</td><td>Good</td></tr>
        <tr><td><code>loadRemote</code> + iframe</td><td>Any / Legacy</td><td>Full</td><td>Fair</td></tr>
      </table>
    </div>
  `;
}
